import { defineMessages } from 'react-intl';

const messages = defineMessages({
  recipientName: {
    description: 'advancedSearch.orders.filters.recipientName',
    defaultMessage: 'Recipient Name',
    id: '8zzuXm',
  },
});

export default messages;
